import { buildClientPortalDestination } from '~/lib/tenantLinks';

export type ApprovalPortalDestination = {
    actionLink: string;
    actionPath: string;
};

export function buildApprovalPortalDestination(options: {
    origin: string;
    tenantId: string;
    clientSlug: string;
    approvalId: string;
}): ApprovalPortalDestination {
    return buildClientPortalDestination({
        origin: options.origin,
        tenantId: options.tenantId,
        clientSlug: options.clientSlug,
        section: 'approvals',
        focusParam: 'focusApprovalId',
        focusValue: options.approvalId,
    });
}
